export default __webpack_public_path__ + "static/media/warning--traffic-signals--g3.675ee0a1.png";